import { get } from 'lodash';

const styles = ({ padding, color }) => ({
  root: {
    alignSelf: 'flex-start',
    display: "flex",
    justifyContent: "Center",
    paddingTop: get(padding, 'p36'),
  },
  content: {
    width: '50%',
    display: "flex",
    alignItems: "center",
    justifyContent: "Center",
    flexDirection: 'column',
    textAlign: "center",
    paddingTop: get(padding, 'p36'),
  },
  header: {
    paddingTop: get(padding, 'p50'),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      height: '67px',
    },
  },
  alternateLogo: {
    marginBottom: 0,
  },
  title: {
    margin: "18px 0 0 0",
    lineHeight: "40px",
  },
  homeButton: {
    '&:focus': {
      border: `1px solid ${get(color, 'primaryButtonBackground')}`,
    },
  },
});

export default styles;